<template>
  <div class="banner">
    <h3 class="banner__message wb-type-copy-strong">
      <wb-icon :name="icon" class="banner__icon" :class="isRTLClass"></wb-icon>
      {{ message }}
    </h3>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue';

import { useDirection } from '../../composables/direction.composable';

export default defineComponent({
  name: 'otb-banner',
  props: {
    message: {
      type: String,
    },
    icon: {
      type: String,
    },
  },
  setup() {
    let { isRTL } = useDirection();

    const isRTLClass = computed((): string => {
      return isRTL.value ? 'banner__icon--rtl' : '';
    });

    return {
      isRTLClass,
    };
  },
});
</script>
<style scoped lang="scss" src="./banner.scss"></style>
